// Base
import { DetailedHTMLProps, HTMLAttributes } from 'react'

// Components
import { Box, Container } from 'yard-utilities/components'

// Styles
import styles from './Section.module.sass'

interface SectionProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  children: React.ReactNode
  padding?: number[]
  backgroundColor?: string
  spacing?: number
  spaceBetween?: boolean
}

const Section = ({
  children,
  padding,
  backgroundColor,
  spacing,
  spaceBetween,
  ...rest
}: SectionProps) => {
  return (
    <section className={styles.section} {...rest}>
      <Box
        className={styles.wrapper}
        padding={{ sm: padding || [0] }}
        backgroundColor={backgroundColor}
        spacing={{ sm: spacing || 0 }}
        style={{ justifyContent: spaceBetween ? 'space-between' : 'stretch' }}
      >
        <Container className={styles.container}>{children}</Container>
      </Box>
    </section>
  )
}

export default Section
